import React from 'react';
import Helmet from "react-helmet";
import {Card, CardGroup, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import speaker7 from '../../assets/images/contents/speaker7.jpg';

export const DatoSriDrUzirMahidin = () => (
  <div>
    <Helmet>
      <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">DatoSriDrUzirMahidin</li>
      </ol>
    </nav>
    {/* <h2>Abstract - Professor Dr. Richard C Millham</h2> <br/>   */}

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker7} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b>YBhg Dato’ Sri Mohd Dr. Uzir Mahidin</b>
    </p>

    <p style={{textAlign:'center'}}>
      Chief Statistician Malaysia & Adjunct Professor of Universiti Teknologi MARA, Malaysia
    </p>

    <br/>

    <h4 style={{textAlign:'center'}}>Analytics and AI: Harnessing the Unconventional Data Sources</h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
      The field of Analytics is broad whereby some of the most important communities include, Statistics, Operational Research (OR), Artificial 
      Intelligence (AI), Business Intelligence (BI), Web Analytics and Data Visualization. In a wider context, Analytics is usually defined as the 
      process of developing actionable insights through data exploration, while AI is exclusively referred to as a completely autonomous process of 
      exploring massive datasets in developing actionable insights using elaborate computer algorithms. The rise of unconventional data usage such as 
      website data and satellite images has been significantly beneficial to the Department of Statistics Malaysia (DOSM) as a national statistics 
      provider to produce complementary statistics in assisting the government’s policy formulation. DOSM has started the implementation of Big Data 
      Analytics (BDA) in producing more reliable and timeliness of official statistics. Initially, there are three (3) main modules in DOSM BDA, namely 
      Trade by Enterprise Characteristics (TEC), Price Intelligence (PI), Public Maturity Assessment on Official Statistics (PMAOS). TEC involves 
      integration of high volume of structured data with fuzzy matching techniques, PI is the modernizing data collection method with web crawling 
      technique, while PMAOS uses text mining technique for sentiment analysis. Additionally, DOSM has launched the Malaysian Economic Monitoring System, 
      Data Visualization that is presented in a dashboard-style of graphical display to easily gain insights and identify patterns and trends from economic 
      data. On top of the existing initiatives, DOSM is actively exploring in BDA and utilizing unconventional data sources; Earth Observation is the 
      exploration of environmental insights with satellite imagery to identify the proportion of population and living quarters in remote and inaccessible 
      areas; Informal Sector and Micro Industry Database and Analytics serve as a single reference of database by integrating a large scale of administrative 
      data with non-traditional data sources i.e. social media & web scraping; and Mobile Positioning Data as a dynamic proxy indicator in assessing economic 
      activity and human commuting patterns. In a nutshell, analytics and AI harness new data sources in generating new statistics. Nonetheless, these new 
      statistics are not intended to replace conventional statistics, but to complement each other to gain richer insights.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
      As a Chief Statistician of the Department of Statistics Malaysia (DOSM), effective February 14, 2017, he has been devoted to his career by serving at 
      DOSM for the past 30 years since his first posting as a Statistician in 1990. He has an extensive experience and specialize in both economic and social 
      statistics where he has served and contributed in various fields of statistics such as national accounts; external trade; industrial & construction; and 
      services. His career has spanned domestically as head of national statistical office, Executive Committee of Institute Statistics Malaysia, Chairman of 
      the Working Group on Statistical Database and the Chairman of the National Organizing Committee of ISI World Statistics Congress 2019. In 2020, he was 
      honoured with 2020 Congress of Unions of Employees in the Public and Civil Services (CUEPACS) Malaysia Labour Day Icon Award. Recently, appointed as the 
      Sixth Census Commissioner by His Majesty the Yang Di-Pertuan Agong XVI, Al-Sultan Abdullah Ri'ayatuddin Al-Mustafa Billah Shah on 1st April 2020.
    </p>

    <p style={{ textAlign:'justify'}}>
      His active participation and significant contribution at the international arena is acknowledged through his appointment as the Chair of the Bureau of the 
      Committee on Statistics of the United Nations Economic and Social Commission for Asia and the Pacific (ESCAP) 2018-2020; Chair of Bureau for the 7th & 8th 
      Sessions of Organization of Islamic Cooperation Statistical Commission (OIC-StatCom) 2018-2019; Executive Committee of International Association of Official 
      Statistics (IAOS) for two consecutive terms 2017-2019 & 2020-2022; Co-Chair Working Group (WG) on the Development of New Strategic Vision of OIC-StatCom; and
      most recently, he is re-appointed as vice-chair of the 7th Bureau of the ESCAP Committee on Statistics, 2020- 2022 terms.
    </p>

    <p style={{ textAlign:'justify'}}>
      He is also a member of various expert groups globally as well as international associations such as the ASEAN Community Statistical System (ACSS), UNWTO Tourism 
      Statistics; Expert Group on Civil Registration and Vital Statistics (CRVS) ESCAP; Member of Friends of Chair Fundamental Principles of Official Statistics 
      (FOC-FPOS) United Nations; High-Level Group for Partnership, Coordination and CapacityBuilding for Monitoring Sustainable Goals (SDG); and the ASEAN Secretariat 
      on SNA Statistics, ISI-South East Asia Network, Regional Programme on Economic Statistics and so on.
    </p>

    <p>Click this <a href = "https://www.iaos-isi.org/index.php/executive-committee-members-2017-2019/201-mohd-uzir-mahidin-member" target="_blank" rel="noreferrer">link</a> to see his further detail bio. <br/>
    </p>

  </div>
)